import useGetTrafficStats from '@/modules/analytics/hooks/useGetTrafficStats.hook';
import SingleStatMetric from './single-stat-metric';
import { useEffect } from 'react';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import { useAnalytics } from '@/modules/analytics/hooks/useAnalytics.hook';
import GridSkeleton from '../../skeletons/GridSkeleton';

const TrafficStats = () => {
  const { state } = usePlayground();
  const { dateFilter, filters } = useAnalytics();
  const getTrafficStats = useGetTrafficStats();

  useEffect(() => {
    if (!state.payload?._id) return;

    getTrafficStats.mutate({
      link_in_bio_id: state.payload._id,
      start_date: dateFilter.start,
      end_date: dateFilter.end,
      ...filters,
    });
  }, [state.payload?._id, dateFilter, filters]);

  if (!getTrafficStats.data)
    return (
      <div className="grid grid-cols-3 md:flex md:items-center md:justify-between gap-4">
        <GridSkeleton />
        <GridSkeleton />
        <GridSkeleton />
        <GridSkeleton />
        <GridSkeleton />
      </div>
    );

  return (
    <div className="grid grid-cols-3 md:flex md:items-center md:justify-between gap-4">
      <SingleStatMetric
        label={
          <span className="flex items-center gap-x-2">
            Unique Visitors <div className="w-2 h-2 rounded-full bg-graph-chart-1" />
          </span>
        }
        value={getTrafficStats.data.data.unique_visitors}
      />
      <SingleStatMetric
        label={
          <span className="flex items-center gap-x-2">
            Unique Clicks <div className="w-2 h-2 rounded-full bg-graph-chart-2" />
          </span>
        }
        value={getTrafficStats.data.data.unique_clicks}
      />
      <SingleStatMetric label="Total Visitors" value={getTrafficStats.data.data.total_visitors} />
      <SingleStatMetric label="Bounce Rate" value={`${getTrafficStats.data.data.bounce_rate}%`} />
      <SingleStatMetric label="Email Subscribers" value={getTrafficStats.data.data.total_subscribers} />
    </div>
  );
};

export default TrafficStats;
